export const isValidUrl = (value: string, supportedExtensions: string[]): boolean => {
    try {
        const url = new URL(value);
        const ext = url.pathname.split(".")[url.pathname.split(".").length - 1];
        return supportedExtensions.includes(ext);
    } catch (error) {
        return false;
    }
};
